module.exports = __webpack_public_path__ + "static/media/ogranicheniya_po_slyzbe.d194d303.doc";